var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.direction_prop,attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20 16L12 8L4 16","stroke":"#007BFF","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }